import { render, staticRenderFns } from "./UserStatistic.vue?vue&type=template&id=667ceff3&"
import script from "./UserStatistic.vue?vue&type=script&lang=js&"
export * from "./UserStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports